import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CategoryComponent } from './category/category.component';
import { SearchProductComponent } from './search-product/search-product.component';
import { SupportComponent } from './support/support.component';
import { ContactComponent } from './contact/contact.component';
import { ProductComponent } from './product/product.component';
import { LanguagesComponent } from './common/languages/languages.component';
import { WheretobuyComponent } from './wheretobuy/wheretobuy.component';
import { AppCustomPreloader } from './app-routing.loader';
import { PrivacyComponent } from './common/footer/privacy/privacy.component';
import { TermsConditionsComponent } from './common/footer/terms-conditions/terms-conditions.component';
import { ForLifeComponent } from './common/footer/for-life/for-life.component';
import { CookiePolicyComponent } from './common/footer/cookie-policy/cookie-policy.component';
import { ProductAreaComponent } from './product-area/product-area.component';
import { AboutComponent } from './about/about.component';
import { NotFoundComponent} from './not-found/not-found.component';
import { CorporateMissionComponent } from './press-release/corporate-mission/corporate-mission.component';
import { MediaCenterComponent } from './press-release/media-center/media-center.component';
import { NewsroomComponent } from './press-release/newsroom/newsroom.component';
import { NewsComponent  } from './press-release/news/news.component';
import { RegisterProductComponent } from './support/register-product/register-product.component';
import { LogosComponent } from './press-release/media-center/logos/logos.component';
import { BrochuresComponent } from './press-release/media-center/brochures/brochures.component';
import { ByCategoryComponent } from './press-release/media-center/by-category/by-category.component';
import { ByModelComponent } from './press-release/media-center/by-model/by-model.component';
import { ProductImagesComponent } from './press-release/media-center/by-category/product-images/product-images.component';
import { HighResolutionComponent } from './press-release/media-center/by-category/product-images/high-resolution/high-resolution.component';

const appRoutes: Routes = [
  { path: ':country/:language', component: HomeComponent, data: { preload: true } },
  { path: ':country/:language/category/:link', component: CategoryComponent },
  {
    path: ':country/:language/product/:link', component: ProductComponent 
    // children: [
    //   { path: '', redirectTo: 'features', pathMatch: 'full' },
    // ]
  },
  { path: ':country/:language/product-area/:link', component: ProductAreaComponent },
  { path: ':country/:language/about', component: AboutComponent },
  { path: ':country/:language/search/:query', component: SearchProductComponent },
  { path: ':country/:language/contact', component: ContactComponent },
  //For Support pagge
  { path: ':country/:language/support', component: SupportComponent },
  { path: ':country/:language/register-product', component: RegisterProductComponent },
  // For Footer,
  { path: ':country/:language/privacy-policy', component: PrivacyComponent },
  { path: ':country/:language/for-life', component: ForLifeComponent },
  { path: ':country/:language/cookie-policy', component: CookiePolicyComponent },
  { path: ':country/:language/terms-conditions', component: TermsConditionsComponent },
  { path: ':country/:language/corporate-mission', component: CorporateMissionComponent },
  { path: ':country/:language/media-center', component: MediaCenterComponent },
  { path: ':country/:language/newsroom', component: NewsroomComponent },
  { path: ':country/:language/news/:id', component: NewsComponent },
  { path: ':country/:language/logos', component: LogosComponent },
  { path: ':country/:language/by-category', component: ByCategoryComponent },
  { path: ':country/:language/by-model', component: ByModelComponent },
  { path: ':country/:language/brochures', component: BrochuresComponent },
  { path: ':country/:language/high-resolution/:link', component: HighResolutionComponent },
  { path: ':country/:language/product-images/:link', component: ProductImagesComponent },

  { path: ':country/:language/languages', component: LanguagesComponent },
  { path: ':country/:language/wheretobuy', component: WheretobuyComponent },

  //not found page
  { path: '**', component: NotFoundComponent },

];


@NgModule({
  imports: [RouterModule.forRoot(appRoutes,
    { preloadingStrategy: AppCustomPreloader })],
  exports: [RouterModule],
  providers: [AppCustomPreloader]
})

export class AppRoutingModule {

}
